// Canonical signature for a technical-property combination, identical to the
// server (Drawing#technical_property_combination_signature): the option names
// sorted ascending, joined as name=value with ';'. The stored preview images are
// keyed by this exact string, so the client must build it the same way or every
// lookup misses and the pane stays on the pending label.
//
// optionNames: the popup's technical-property option names.
// values: { optionName => currentValue }.
const technicalPropertyCombinationSignature = (optionNames, values) => (
  [...optionNames]
    .sort()
    .map((name) => `${name}=${values[name]}`)
    .join(';')
);

export default technicalPropertyCombinationSignature;
